// assets
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import { INavGroup } from '../models/Menu';
import { ROUTES } from '../routes/routes';

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export const FeedRoutes: INavGroup = {
  id: 'group-feed',
  title: 'Linha do Tempo',
  icon: <FeedOutlinedIcon />,
  type: 'group',
  level: 1,
  url: ROUTES.authenticated.dashboard
};
